import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_HeadshotGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/headshot-generator',
			name: 'AI Headshot Generator | Professional Profile Photos | Lift',
			description:
				'Create realistic professional headshots in minutes. AI-powered headshot generator — perfect for LinkedIn, resumes, or business profiles. No photoshoot needed. Try Lift Headshot Generator now.',
			url: 'https://liftapp.ai/headshot-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/headshot-generator#product' },
				{ '@id': 'https://liftapp.ai/headshot-generator#howto' },
				{ '@id': 'https://liftapp.ai/headshot-generator#benefits' },
				{ '@id': 'https://liftapp.ai/headshot-generator#faq' },
				{ '@id': 'https://liftapp.ai/headshot-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/headshot-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/headshot-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/headshot-generator#product',
			name: 'AI Headshot Generator',
			description:
				'Create realistic professional headshots in minutes. AI-powered headshot generator — perfect for LinkedIn, resumes, or business profiles. No photoshoot needed. Try Lift Headshot Generator now.',
			url: 'https://liftapp.ai/headshot-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/headshot-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'We create a custom AI model',
					text: 'Our AI captures your face, keeps every detail, and generates studio-quality headshots for a flawless, natural look',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/headshot-generator#benefits',
			name: 'Who can benefit from AI Headshot Generator?',
			description: '',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'The AI Headshot Generator is perfect for anyone who values polished, professional images',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Job seekers can upgrade their resumes and LinkedIn with high-quality, confidence-boosting portraits',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators and influencers can refresh their profiles, making them more eye-catching and brand-consistent',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Teams and companies can unify staff photos without expensive studio sessions',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'This feature delivers quick, premium-quality results — a must-have for both personal and business use.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.8ec950af.webp',
				name: 'AI Headshot Generator by Lift',
				description: 'Professional headshot created with AI',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/headshot-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Headshot Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Headshot Generator is a premium online tool that transforms your selfies into professional portraits — perfect for LinkedIn, resumes, or company profiles.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Headshot Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI detects your facial features with deep learning models, applies realistic lighting, backgrounds, and outfits, while keeping your natural look. Everything is processed in the cloud — no manual editing needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep my face and fine details accurate?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Headshot Generator uses advanced face preservation to capture your true features, keeping details like hair, skin texture, and expression for realistic, high-quality portraits.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/headshot-generator#why-lift',
			name: 'Why Lift’s AI Headshot Generator stands out',
			description:
				'Lift’s AI Headshot Generator makes it simple to create polished, professional profile photos in minutes. With powerful AI, multi-platform support, and affordable pricing, it’s the easiest way to get studio-quality headshots without a photoshoot.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.04caa584.webp',
				name: 'Professional AI-generated business headshot',
				description:
					'Illustration of Lift’s AI Headshot Generator highlighting professional results, AI accuracy, multi-platform access, and affordability.',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/headshot-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/headshot-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Object Remover',
					item: 'https://liftapp.ai/headshot-generator',
				},
			],
		},
	],
};
